import { useState, useMemo, useEffect, useRef } from"react";
import { Search, X } from"lucide-react";
import { searchAccounts } from"@/lib/pcgUtils";
import { getClass } from"@/data/classMeta";

export default function SearchBar({ onSelect }) {
 const [q, setQ] = useState("");
 const [open, setOpen] = useState(false);
 const ref = useRef(null);

 const results = useMemo(() => searchAccounts(q), [q]);

 useEffect(() => {
 const onClick = (e) => {
 if (ref.current && !ref.current.contains(e.target)) setOpen(false);
 };
 document.addEventListener("mousedown", onClick);
 return () => document.removeEventListener("mousedown", onClick);
 }, []);

 return (
 <div ref={ref} className="relative w-full">
 <div className="relative">
 <Search
 size={18}
 className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"
 />
 <input
 data-testid="search-input"
 value={q}
 onChange={(e) => {
 setQ(e.target.value);
 setOpen(true);
 }}
 onFocus={() => q && setOpen(true)}
 placeholder="Rechercher par numéro (ex: 401) ou par libellé (ex: TVA, banque, salaires)…"
 className="w-full bg-white border border-keyto rounded-lg pl-11 pr-11 py-3 text-base shadow-keyto-sm focus:outline-none focus:border-[#2D6BE0] focus:ring-2 focus:ring-[#2D6BE0]/20 transition-all placeholder:text-slate-400 placeholder:text-sm"
 />
 {q && (
 <button
 data-testid="search-clear"
 onClick={() => {
 setQ("");
 setOpen(false);
 }}
 className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:bg-slate-100 rounded-md"
 aria-label="Effacer la recherche"
 >
 <X size={16} className="text-slate-500" />
 </button>
 )}
 </div>

 {open && results.length > 0 && (
 <div
 data-testid="search-results"
 className="absolute z-30 mt-2 w-full max-h-96 overflow-y-auto bg-white border border-keyto rounded-lg shadow-keyto-lg"
 >
 {results.map((r) => {
 const cls = getClass(r.classe);
 return (
 <button
 data-testid={`search-result-${r.num}`}
 key={r.num}
 onClick={() => {
 onSelect(r.num);
 setOpen(false);
 setQ("");
 }}
 className="w-full text-left flex items-center gap-3 px-4 py-2.5 hover:bg-slate-50 border-b border-slate-100 last:border-b-0 transition-colors"
 >
 <span
 className="w-2 h-2 rounded-full shrink-0"
 style={{ backgroundColor: cls.color.primary }}
 />
 <span
 className="font-mono font-bold text-sm shrink-0"
 style={{ color: cls.color.text }}
 >
 {r.num}
 </span>
 <span className="text-sm text-slate-700 truncate">{r.lib}</span>
 </button>
 );
 })}
 </div>
 )}

 {open && q && results.length === 0 && (
 <div
 data-testid="search-empty"
 className="absolute z-30 mt-2 w-full bg-white border border-keyto rounded-lg shadow-keyto-lg p-4 text-sm text-slate-500"
 >
 Aucun compte trouvé pour « {q} ».
 </div>
 )}
 </div>
 );
}
